<footer class="footer h-100 px-5">
  <div class="d-flex align-items-center justify-content-between h-100">
    <div class="d-flex align-items-center gap-3">
      <img [src]="logoUrl" [alt]="companyName + ' Logo'" class="footer-logo" />
      <h3 class="mb-0">&copy; {{ currentYear }}</h3>
    </div>
    <div class="d-flex align-items-center gap-4">
      <ng-container *ngFor="let menu of menus">
        <ng-container *ngIf="menu.isActive">
          <ng-container *ngFor="let menuItem of menu.profileMenuItems">
            <a
              *ngIf="menuItem.isActive"
              [routerLink]="['/faq/' + menuItem.profileMenuType]"
            >
              {{ languageService.currentLanguage == 'en' ? menuItem.titleEn : menuItem.titleAr }}
            </a>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</footer>
